import { Component, OnDestroy, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { LoaderService } from "@ctsolution/ct-webapi";

@Component({
  selector: "app-spinner",
  template: `
    <div class="spinner-overlay" *ngIf="isSpinnerVisible">
      <img src="assets/images/SpinnerCarrello.gif" alt="Loading..." class="spinner-image">
    </div>`,
  styles: [`
    .spinner-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      backdrop-filter: blur(3px);
    }

    .spinner-image {
      width: 120px;
      height: 120px;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {

  public isSpinnerVisible = true;

  constructor(
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.loaderService
      .isLoading
      .subscribe((v) => {
        this.isSpinnerVisible = v; // ← Usa direttamente il valore boolean
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
